import { __decorate } from "tslib";
/// <reference types="oidc-client" />
import SHA3 from 'crypto-js/sha3';
import hmacSHA3 from 'crypto-js/hmac-sha3';
import { action, observable } from 'mobx';
import Core from '../Core';
import AppHistory from './AppHistory';
import CordovaUtils from './Cordova';
import ElectronUtils from './Electron';
import { PublicRoutes } from './PublicRoutes';
import SecureStorage from './SecureStorage';
var UserManagerHelpers = /** @class */ (function () {
    /**
     * Class constructor
     * @returns {void}
     * */
    function UserManagerHelpers() {
        this.AppLocked = true;
        this.HasRefreshToken = false;
        this.IsSignedIn = false;
        /**base app sign in path */
        this.SignInPath = PublicRoutes.Signin;
        /**Name of the secure storage object for the refresh token */
        this.SsRefreshTokenName = 'RefreshToken';
        /**Name of the locked object that determines if the APP is locked */
        this.SsLockedName = 'Locked';
        /**Secure storage pin code key */
        this.SsPinKey = 'PinCode';
        /**Secure user profile object */
        this.SsUserProfile = 'UserProfile';
        /**Store demo username */
        this.DemoUserName = 'demo@post.ch';
        return;
    }
    /**
     * Class initializer
     * @param {IAuthority} authority Authority configuration
     */
    UserManagerHelpers.prototype.Initialize = function (authority) {
        var that = this;
        return new Promise(function (resolve) {
            try {
                that.AuthorityEndPoint = authority.Authority;
                that.ClientId = authority.ClientId;
                that.FirstPage = authority.FirstPage;
                that.InitManager(authority);
                if (CordovaUtils.IsCordova) {
                    that.AssignNativeHandleOpenUrl();
                }
                that.IsRefreshTokenAvailable()
                    .then(function (res) {
                    that.HasRefreshToken = res;
                    that.GetUser()
                        .then(function (user) {
                        if (user !== null && user !== undefined && !user.expired) {
                            that.IsSignedIn = true;
                        }
                        if (CordovaUtils.IsElectron && that.HasRefreshToken) {
                            that.AppUnlock()
                                .catch(function (ex) { console.error(ex); })
                                .then(function () {
                                that.AppLocked = false;
                                resolve();
                            });
                        }
                        else {
                            resolve();
                        }
                    }).catch(function () {
                        resolve();
                    });
                })
                    .catch(function () {
                    resolve();
                });
            }
            catch (ex) {
                console.error(ex);
                resolve();
            }
        });
    };
    /**
     * Initialize user manager
     * @param {IAuthority} authority Authority configuration
     */
    UserManagerHelpers.prototype.InitManager = function (authority) {
        var that = this;
        that.Manager = new window["Oidc"].UserManager(this.GetManagerConfig(authority));
        that.Manager.events.addSilentRenewError(function (evt) {
            console.error("[UserManager-9] - Error renewing sign in; Siging out");
            that.SignOutRedirect();
        });
        that.Manager.events.addAccessTokenExpiring(function () {
            that.RenewTokens()
                .catch(function (err) {
                console.error("[User mananger]: Error renewing tokens");
            });
        });
        if (process.env.NODE_ENV !== 'production') {
            window["Oidc"].Log.logger = console;
        }
    };
    /**
     * Get OIDC manager configuration
     * @param {IAuthority} authority OIDC configuration
     */
    UserManagerHelpers.prototype.GetManagerConfig = function (authority) {
        var redirectUri = authority.RedirectUri;
        var postLogoutUri = authority.PostLogoutRedirectUri;
        var silentRedirectUri = authority.SilentRedirectUri;
        var result;
        if (!CordovaUtils.IsCordova) {
            redirectUri = window.location.origin + '/' + redirectUri;
            postLogoutUri = window.location.origin + '/' + postLogoutUri;
            silentRedirectUri = "https://" + window.location.host + '/' + silentRedirectUri;
        }
        else {
            redirectUri = authority.NativeDeepLink + '://' + redirectUri;
            postLogoutUri = authority.NativeDeepLink + '://' + postLogoutUri;
            silentRedirectUri = authority.NativeDeepLink + '://' + silentRedirectUri;
        }
        result = {
            authority: authority.Authority,
            client_id: "" + authority.ClientId + (CordovaUtils.IsCordova ? '_native' : ''),
            redirect_uri: redirectUri,
            response_type: authority.ResponseType,
            scope: authority.Scope + " " + (CordovaUtils.IsCordova ? ' offline_access' : ''),
            post_logout_redirect_uri: postLogoutUri,
            silent_redirect_uri: silentRedirectUri,
            automaticSilentRenew: CordovaUtils.IsCordova ? false : authority.AutomaticSilentRenew,
            revokeAccessTokenOnSignout: true,
            prompt: 'login'
        };
        if (!CordovaUtils.IsCordova) {
            delete result.prompt;
        }
        return result;
    };
    /**Add secure browser tab hanfle open url function */
    UserManagerHelpers.prototype.AssignNativeHandleOpenUrl = function () {
        var that = this;
        window["handleOpenURL"] = function (url) {
            setTimeout(function () {
                try {
                    if (url.indexOf('signin-callback.html') > -1) {
                        that.Manager.processSigninResponse(url)
                            .then(function (user) {
                            SecureStorage.Store(JSON.stringify(user.profile), that.SsUserProfile)
                                .then(function () {
                                SecureStorage.Store(user["refresh_token"], that.SsRefreshTokenName)
                                    .then(function () {
                                    if (CordovaUtils.IsElectron) {
                                        ElectronUtils.CloseIdsWindow();
                                        that.AppUnlock()
                                            .then(function () {
                                            Core.InitApiDependencies()
                                                .then(function () {
                                                that.AppLocked = false;
                                                that.FlagIsSignedIn(true);
                                                that.HasRefreshToken = true;
                                            })
                                                .catch(function (err) {
                                                console.error(err);
                                                that.SignOutRedirect();
                                            });
                                        });
                                    }
                                    else {
                                        that.FlagIsSignedIn(true);
                                        that.HasRefreshToken = true;
                                    }
                                })
                                    .catch(function (err) {
                                    console.error(err);
                                    that.SignOutRedirect();
                                });
                            })
                                .catch(function (err) {
                                console.error(err);
                                that.SignOutRedirect();
                            });
                        })
                            .catch(function (err) {
                            console.error(err);
                            that.SignOutRedirect();
                        });
                    }
                }
                catch (err) {
                    console.error(err);
                }
            }, 0);
        };
    };
    /**
     * Try sign in user without redirect
     * @returns {OidcClient.User} User configuration
     * */
    UserManagerHelpers.prototype.SilentSignIn = function () {
        var that = this;
        return new Promise(function (resolve) {
            that.Manager.signinSilent().then(function (usr) {
                resolve(usr);
            }).catch(function (err) {
                console.error(err);
                resolve(null);
            });
        });
    };
    /**
     * Redirect user to identity server
     * @param {string} location Current user location
     */
    UserManagerHelpers.prototype.SignInRedirect = function (location) {
        var that = this;
        var returnUrl = '';
        var curPath = typeof (location) === 'string' ? location : location === undefined ? '' : location.pathname;
        if (curPath.indexOf(that.SignInPath) > -1 || curPath === '/' || curPath === '') {
            returnUrl = that.FirstPage;
        }
        else {
            returnUrl = curPath;
        }
        var stateData = {
            returnUrl: returnUrl
        };
        that.Manager.clearStaleState().then(function () {
            that.Manager.removeUser().then(function () {
                if (!CordovaUtils.IsCordova) {
                    that.Manager.signinRedirect({
                        state: stateData //the property name MUST BE state 
                    })
                        .catch(function (err) {
                        console.error(err);
                    });
                }
                else {
                    that.Manager.createSigninRequest()
                        .then(function (signInRequest) {
                        CordovaUtils.OpenSystemBrowser(signInRequest.url, true);
                    })
                        .catch(function (err) {
                        console.error(err);
                    });
                }
            });
        });
    };
    /**
     * Set is signed in value
     * @param {boolean} IsSignedIn Flags if the user is signed in
     * */
    UserManagerHelpers.prototype.FlagIsSignedIn = function (IsSignedIn) {
        this.IsSignedIn = IsSignedIn;
    };
    /**Signout and redirect */
    UserManagerHelpers.prototype.SignOutRedirect = function () {
        var that = this;
        if (!CordovaUtils.IsCordova) {
            that.Manager.signoutRedirect();
        }
        else {
            that.Manager.revokeAccessToken()
                .catch(function (err) {
                console.error(err);
            })
                .then(function () {
                that.Manager.removeUser()
                    .catch(function (err) {
                    console.error(err);
                })
                    .then(function () {
                    SecureStorage.ClearStorage(!CordovaUtils.IsElectron ? null : [that.SsRefreshTokenName, that.SsUserProfile])
                        .catch(function (ex) {
                        console.error(ex);
                    })
                        .then(function () {
                        that.FlagIsSignedIn(false);
                        that.HasRefreshToken = false;
                        if (!CordovaUtils.IsElectron) {
                            that.AppLocked = true;
                        }
                        AppHistory.Push(that.SignInPath);
                    });
                });
            });
        }
    };
    /**
     * Get current user data
     * @returns {Promise<OidcClient.User>} Promise with the user configuration
     * */
    UserManagerHelpers.prototype.GetUser = function () {
        var that = this;
        return new Promise(function (resolve) {
            that.Manager.getUser().then(function (user) {
                if (user !== null) {
                    if (user.expired) {
                        that.SignOutRedirect();
                    }
                    else {
                        resolve(user);
                    }
                }
                else {
                    resolve(null);
                }
            }).catch(function (err) {
                console.error(err);
                AppHistory.Push(that.SignInPath);
                resolve(null);
            });
        });
    };
    /**
     * Returns the user access token
     * @returns {string} User access token
     */
    UserManagerHelpers.prototype.GetAccessToken = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.GetUser()
                .then(function (usr) {
                resolve(usr.access_token);
            })
                .catch(function () {
                resolve("");
            });
        });
    };
    /**
     * Request new tokens from token endpoint
     * @returns {Promise<boolean>} Return a promise with true if tokens were renewed
     */
    UserManagerHelpers.prototype.RenewTokens = function () {
        var _this = this;
        var that = this;
        return new Promise(function (resolve, reject) {
            if (CordovaUtils.IsCordova) {
                SecureStorage.Get(_this.SsRefreshTokenName)
                    .then(function (refreshToken) {
                    that.RequestNewTokens(refreshToken)
                        .then(function (tokens) {
                        SecureStorage.Store(tokens.refresh_token, _this.SsRefreshTokenName)
                            .then(function () {
                            that.Manager.storeUser(new window["Oidc"].User(tokens));
                            resolve(true);
                        }).catch(function (err) {
                            reject();
                        });
                    }).catch(function (err) {
                        reject();
                    });
                }).catch(function (err) {
                    reject();
                });
            }
            else {
                resolve(null);
            }
        });
    };
    /**
     * Request new tokens from identy server
     * @param {string} refreshToken User refresh token
     * @returns {Promise<any>} Promise with token (on success)
     */
    UserManagerHelpers.prototype.RequestNewTokens = function (refreshToken) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            /** Andre, stop! You will read this in some time and say: "Ah, I can make this a fetch".
              * NO STUPID YOU CANNOT! Otherwise you would have written it like that! DUH! */
            var xhrRequest = new XMLHttpRequest();
            var params = "refresh_token=" + refreshToken + "&grant_type=refresh_token&client_id=" + _this.ClientId + (CordovaUtils.IsCordova ? '_native' : '');
            xhrRequest.open('POST', process.env.REACT_APP_BASEPI + '/api/identityserver/tokenproxy/connect/token', true);
            xhrRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrRequest.onreadystatechange = function () {
                if (xhrRequest.readyState === 4) {
                    if (xhrRequest.status === 200) {
                        resolve(JSON.parse(xhrRequest.responseText));
                    }
                    else {
                        reject();
                    }
                }
            };
            xhrRequest.onerror = function () {
                reject();
            };
            xhrRequest.send(params);
        });
    };
    /**
     * Check if there is an available refresh token
     * @returns {Promise<boolean>} Promise with true if a refresh token is available, false on error
     * */
    UserManagerHelpers.prototype.IsRefreshTokenAvailable = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (CordovaUtils.IsCordova) {
                SecureStorage.Get(_this.SsRefreshTokenName)
                    .then(function () { resolve(true); })
                    .catch(function () { resolve(false); });
            }
            else {
                resolve(false);
            }
        });
    };
    /**
     * Check if app is locked
     * @returns {Promise<boolean>}
     * */
    UserManagerHelpers.prototype.IsAppLocked = function () {
        var _this = this;
        return new Promise(function (resolve) {
            SecureStorage.Get(_this.SsLockedName)
                .then(function (value) {
                resolve(value.toLowerCase() === 'false' ? false : true);
            })
                .catch(function (err) {
                resolve(true);
            });
        });
    };
    /**
     * Validate pin and unlock APP
     * @param {string} pin Pin to validate
     * @returns {Promise<boolean>} Promise of boolean. True if pin validated and app unlocked, false otherwise
     */
    UserManagerHelpers.prototype.ValidatePin = function (pin) {
        var that = this;
        return new Promise(function (resolve) {
            that.HashPin(pin)
                .then(function (compareHash) {
                that.GetHashedPin()
                    .then(function (storedHash) {
                    if (storedHash === compareHash) {
                        that.AppUnlock()
                            .then(function (res) {
                            resolve(res);
                        });
                    }
                    else {
                        resolve(false);
                    }
                });
            })
                .catch(function (err) {
                console.error(err);
                resolve(false);
            });
        });
    };
    /**
     * Unlock APP
     * @returns {Promise<boolean>} Promise of boolean. True app unlocked, false otherwise
     * */
    UserManagerHelpers.prototype.AppUnlock = function () {
        var that = this;
        return new Promise(function (resolve) {
            that.SetAppLockedValue("false")
                .then(function () {
                that.RenewTokens()
                    .then(function (res) {
                    if (res) {
                        that.FlagIsSignedIn(true);
                        resolve(true);
                    }
                    else {
                        resolve(false);
                        that.SignOutRedirect();
                    }
                })
                    .catch(function () {
                    resolve(false);
                });
            })
                .catch(function (err) {
                console.error(err);
                resolve(false);
            });
        });
    };
    /**Lock app to pin screen */
    UserManagerHelpers.prototype.LockApp = function () {
        var that = this;
        that.SetAppLockedValue("true")
            .catch(function (ex) {
            console.error(ex);
        })
            .then(function () {
            that.Manager.removeUser()
                .catch(function (ex) {
                console.error(ex);
            })
                .then(function () {
                if (!CordovaUtils.IsElectron) {
                    that.AppLocked = true;
                }
            });
        });
    };
    /**
     * Set secure storage variable with unlocked value
     * @returns {Promise<any>} Promise of any
     * */
    UserManagerHelpers.prototype.SetAppLockedValue = function (locked) {
        var _this = this;
        var that = this;
        return new Promise(function (resolve) {
            if (!CordovaUtils.IsElectron) {
                SecureStorage.Remove(_this.SsLockedName)
                    .catch(function () { })
                    .then(function () {
                    SecureStorage.Store(locked, that.SsLockedName)
                        .catch(function () { })
                        .then(function () {
                        resolve();
                    });
                });
            }
            else {
                resolve();
            }
        });
    };
    /**
     * Save pin to secure storage
     * @param {string} pin Pin value to store
     * @returns {Promise<boolean>} Promise of boolean. True if stored OK, false on error
     */
    UserManagerHelpers.prototype.SavePin = function (pin) {
        var that = this;
        return new Promise(function (resolve) {
            that.HashPin(pin)
                .then(function (hashValue) {
                SecureStorage.Store(hashValue, that.SsPinKey)
                    .then(function () {
                    resolve(true);
                })
                    .catch(function (err) {
                    console.error(err);
                    resolve(false);
                });
            })
                .catch(function (err) {
                console.error("err");
                resolve(false);
            });
        });
    };
    /**
     * Check if the user already has a PIN
     * @returns {Promise<boolean>} Promise of boolean. Tue if user has PIN, false otherwise
     * */
    UserManagerHelpers.prototype.HasPin = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.GetHashedPin()
                .then(function (res) { res === '' ? resolve(false) : resolve(true); })
                .catch(function () { resolve(false); });
        });
    };
    /**
     * Get PIN hash value from secure storage
     * @returns {Promise<string>} Promise of string with the hashed PIN
     * */
    UserManagerHelpers.prototype.GetHashedPin = function () {
        var _this = this;
        return new Promise(function (resolve) {
            SecureStorage.Get(_this.SsPinKey)
                .then(function (res) { resolve(res); })
                .catch(function () { resolve(''); });
        });
    };
    /**
     * Hash pin value
     * @param {Promise<string>} pin Promise with the hashed value
     */
    UserManagerHelpers.prototype.HashPin = function (pin) {
        var _this = this;
        var key = '';
        return new Promise(function (resolve, reject) {
            _this.GetUserProfile()
                .then(function (userProfile) {
                key = userProfile.sub.substring(10, 28);
                key += userProfile.sub.substring(0, 8);
                key = key.replace(/-/g, '');
                resolve(hmacSHA3(SHA3(pin), key).toString());
            })
                .catch(function (err) {
                console.error(err);
                reject();
            });
        });
    };
    /**
     * Get user profile data
     * @returns {Promise<any>} Json data with the user profile
     * */
    UserManagerHelpers.prototype.GetUserProfile = function () {
        var _this = this;
        return new Promise(function (resolve) {
            SecureStorage.Get(_this.SsUserProfile)
                .then(function (userProfile) {
                resolve(JSON.parse(userProfile));
            })
                .catch(function (err) {
                console.error(err);
                resolve(null);
            });
        });
    };
    /**
     * Get current user username
     * @returns {Promise<string>} Returns a promise of type string the the current user usernames
     * */
    UserManagerHelpers.prototype.GetUserName = function () {
        var that = this;
        return new Promise(function (resolve) {
            if (CordovaUtils.IsCordova) {
                that.GetUserProfile().then(function (userProfile) {
                    that.IsDemoUser(userProfile.name).then(function (isDemo) {
                        resolve(isDemo ? that.DemoUserName : userProfile.name);
                    });
                });
            }
            else {
                that.GetUser().then(function (user) {
                    that.IsDemoUser(user.profile.name).then(function (isDemo) {
                        resolve(isDemo ? that.DemoUserName : user.profile.name);
                    });
                });
            }
        });
    };
    /**
     * Check if tje current user is the demo user
     * @param {string} username If empty, get the user from storage, otherwise compare value received
     * @returns {boolean} Returns true if it is the demo user, false otherwise
     */
    UserManagerHelpers.prototype.IsDemoUser = function (username) {
        var _this = this;
        if (username === void 0) { username = ''; }
        var that = this;
        return new Promise(function (resolve) {
            if (username === '') {
                _this.GetUserName().then(function (storedUser) {
                    if (storedUser === that.DemoUserName) {
                        resolve(true);
                    }
                    else {
                        resolve(false);
                    }
                });
            }
            else {
                if (username === 'spcw@post.ch') {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }
        });
    };
    __decorate([
        observable
    ], UserManagerHelpers.prototype, "AppLocked", void 0);
    __decorate([
        observable
    ], UserManagerHelpers.prototype, "HasRefreshToken", void 0);
    __decorate([
        observable
    ], UserManagerHelpers.prototype, "IsSignedIn", void 0);
    __decorate([
        action
    ], UserManagerHelpers.prototype, "FlagIsSignedIn", null);
    __decorate([
        action
    ], UserManagerHelpers.prototype, "SignOutRedirect", null);
    __decorate([
        action
    ], UserManagerHelpers.prototype, "ValidatePin", null);
    __decorate([
        action
    ], UserManagerHelpers.prototype, "AppUnlock", null);
    __decorate([
        action
    ], UserManagerHelpers.prototype, "LockApp", null);
    return UserManagerHelpers;
}());
export { UserManagerHelpers };
var UserManager = new UserManagerHelpers();
export default UserManager;
//# sourceMappingURL=UserManager.js.map